{
  "dashboard": {
    "title": "Tableau de bord",
    "description": "Bienvenue dans votre tableau de bord",
    "patients": "Patients",
    "evaluations": "Evaluations",
    "patientsDescription": "Gerer vos patients",
    "evaluationsDescription": "Gerer vos evaluations",
    "trialCallout": {
      "title": "Ajoutez votre premier praticien pour demarrer votre essai gratuit de {{days}} jours",
      "description": "Chaque praticien dispose de son propre compte pour realiser ses evaluations depuis l'application mobile MetaDevProfile. L'ajout de votre premier praticien active automatiquement votre essai gratuit.",
      "cta": "Ajouter mon premier praticien"
    },
    "stats": {
      "subscription": {
        "title": "Abonnement",
        "seats": "Sieges",
        "monthlyCost": "Cout mensuel",
        "status": {
          "active": "Actif",
          "trialing": "Essai",
          "paused": "En pause",
          "past_due": "En retard",
          "canceled": "Annule",
          "unpaid": "Impaye",
          "none": "Aucun abonnement",
          "incomplete": "Incomplet"
        }
      },
      "users": {
        "title": "Praticiens",
        "total": "Total",
        "active": "Actifs",
        "seeMore": "Voir plus",
        "recentUsers": "Praticiens recents"
      },
      "deviceRequests": {
        "title": "Demandes d'Appareils",
        "pending": "En attente",
        "seeMore": "Voir plus",
        "recentRequests": "Demandes recentes",
        "cardTitle": "Demandes d'approbation d'appareils",
        "cardDescription": "Gerez les demandes d'autorisation d'appareils de vos membres",
        "cardDescriptionPopulated": "Examinez et approuvez les demandes d'autorisation d'appareils de vos membres",
        "noPending": "Aucune demande d'appareil en attente",
        "unknownDevice": "Appareil inconnu",
        "unknownType": "Type inconnu",
        "at": "a",
        "approve": "Approuver",
        "deny": "Refuser"
      }
    }
  },
  "navigation": {
    "general": "General",
    "dashboard": "Tableau de bord",
    "users": "Utilisateurs",
    "groups": "Groupes",
    "billing": "Facturation",
    "roles": {
      "institution": "Institution",
      "practitioner": "Praticien"
    },
    "emailVerification": {
      "title": "Verifiez votre Email",
      "description": "Verifiez votre email et cliquez sur le lien pour finaliser votre compte.",
      "resendButton": "Renvoyer",
      "resendSuccess": "Email de verification envoye ! Veuillez verifier votre boite de reception."
    }
  },
  "users": {
    "title": "Utilisateurs",
    "description": "Gerez les praticiens de votre institution",
    "inviteUser": "Inviter un praticien",
    "searchPlaceholder": "Rechercher par nom ou email...",
    "noUsers": "Aucun utilisateur trouve",
    "table": {
      "name": "Nom",
      "email": "Email",
      "phone": "Telephone",
      "status": "Statut",
      "inviteDate": "Date d'invitation",
      "actions": "Actions"
    },
    "status": {
      "pending": "En attente",
      "accepted": "Accepte",
      "declined": "Refuse"
    },
    "actions": {
      "resendInvite": "Renvoyer l'invitation",
      "revokeAccess": "Revoquer l'acces",
      "viewDetails": "Voir les details",
      "resetPassword": "Reinitialiser le mot de passe",
      "edit": "Modifier le praticien",
      "delete": "Supprimer le praticien"
    },
    "invite": {
      "title": "Inviter un praticien",
      "email": "Adresse email",
      "emailPlaceholder": "praticien@exemple.com",
      "send": "Envoyer l'invitation",
      "cancel": "Annuler",
      "success": "Invitation envoyee avec succes",
      "error": "Erreur lors de l'envoi de l'invitation"
    },
    "filters": {
      "all": "Tous",
      "pending": "En attente",
      "accepted": "Acceptes",
      "declined": "Refuses"
    },
    "details": {
      "title": "Details de l'utilisateur",
      "description": "Informations completes sur ce membre de l'institution",
      "personalInfo": "Informations personnelles",
      "name": "Nom complet",
      "email": "Email",
      "phone": "Telephone",
      "gender": "Sexe",
      "genderMan": "Homme",
      "genderWoman": "Femme",
      "genderOther": "Autre",
      "institutionInfo": "Informations institution",
      "inviteStatus": "Statut d'invitation",
      "inviteDate": "Date d'invitation",
      "devices": {
        "title": "Appareils autorises ({{count}})",
        "status": {
          "approved": "Approuve",
          "pending": "En attente",
          "rejected": "Refuse",
          "revoked": "Revoque"
        },
        "defaultName": "Appareil {{type}}",
        "type": "Type : {{type}}",
        "createdAt": "Cree le : {{date}}",
        "lastUsed": "Derniere utilisation : {{date}}",
        "revokeAccess": "Revoquer l'acces",
        "revoking": "Revocation...",
        "noDevices": "Aucun appareil autorise",
        "revokeDialog": {
          "title": "Revoquer l'acces de l'appareil",
          "description": "Etes-vous sur de vouloir revoquer l'acces pour l'appareil",
          "warning": "L'utilisateur devra demander une nouvelle autorisation pour utiliser cet appareil."
        }
      }
    },
    "create": {
      "button": "Creer un compte",
      "trialCapReached": "Limite de sieges de l'essai atteinte ({{count}}). Contactez-nous pour l'augmenter.",
      "title": "Creer un compte utilisateur",
      "description": "Creez directement un compte pour un praticien de votre institution",
      "firstName": "Prenom",
      "firstNamePlaceholder": "Entrez le prenom",
      "lastName": "Nom",
      "lastNamePlaceholder": "Entrez le nom de famille",
      "email": "Adresse email",
      "emailPlaceholder": "praticien@exemple.com",
      "phone": "Telephone",
      "phonePlaceholder": "Optionnel",
      "password": "Mot de passe",
      "passwordPlaceholder": "Minimum 6 caracteres",
      "confirm": "Creer le compte",
      "cancel": "Annuler",
      "success": "Compte cree avec succes",
      "error": "Erreur lors de la creation du compte"
    },
    "addSeat": {
      "title": "Ajouter un siege",
      "description": "L'ajout d'un nouvel utilisateur ajoutera un siege a votre abonnement. Veuillez verifier les changements de cout ci-dessous.",
      "currentSeats": "Sieges actuels",
      "newSeats": "Nouveaux sieges",
      "currentMonthlyCost": "Cout mensuel actuel",
      "additionalCost": "Cout supplementaire",
      "newMonthlyCost": "Nouveau cout mensuel",
      "confirm": "Confirmer et creer",
      "cancel": "Annuler",
      "previewError": "Impossible de charger l'apercu des couts. Veuillez reessayer.",
      "trial": {
        "title": "Essai gratuit de {{count}} jours",
        "description": "Aucun paiement n'est demande aujourd'hui. La facturation mensuelle ci-dessous ne demarrera qu'a la fin de votre periode d'essai.",
        "afterTrialLabel": "Cout mensuel apres l'essai"
      },
      "trialOngoing": {
        "title": "Siege inclus dans votre essai en cours",
        "description": "Aucun paiement n'est demande. La facturation mensuelle ci-dessous ne demarrera qu'a la fin de votre periode d'essai."
      },
      "success": {
        "trial": "Utilisateur cree ! Votre essai gratuit a demarre.",
        "noPayment": "Utilisateur cree !"
      },
      "payment": {
        "description": "Saisissez vos informations de paiement pour finaliser l'abonnement.",
        "pay": "Payer maintenant",
        "success": "Paiement reussi ! Utilisateur cree.",
        "finalizing": "Finalisation en cours...",
        "genericError": "Une erreur est survenue lors du paiement. Veuillez reessayer."
      }
    },
    "revokeDialog": {
      "title": "Revoquer l'acces",
      "description": "Etes-vous sur de vouloir revoquer l'acces de {name} ? Cette action supprimera l'utilisateur de votre institution.",
      "confirm": "Revoquer l'acces",
      "cancel": "Annuler",
      "revoking": "Revocation..."
    },
    "edit": {
      "title": "Modifier le praticien",
      "description": "Mettez a jour les informations de ce praticien",
      "firstName": "Prenom",
      "firstNamePlaceholder": "Entrez le prenom",
      "lastName": "Nom",
      "lastNamePlaceholder": "Entrez le nom de famille",
      "email": "Adresse email",
      "emailPlaceholder": "praticien@exemple.com",
      "phone": "Telephone",
      "phonePlaceholder": "Optionnel",
      "confirm": "Enregistrer les modifications",
      "cancel": "Annuler",
      "success": "Praticien mis a jour avec succes",
      "error": "Erreur lors de la mise a jour du praticien"
    },
    "delete": {
      "title": "Supprimer le praticien",
      "description": "Etes-vous sur de vouloir supprimer {{name}} de votre institution ?",
      "warning": "Le siege sera retire de votre abonnement. Si ce praticien n'a aucun patient ni evaluation enregistres, son compte sera definitivement supprime et son adresse email pourra etre reutilisee pour un nouveau compte.",
      "confirm": "Supprimer",
      "cancel": "Annuler",
      "success": "Praticien supprime avec succes",
      "error": "Erreur lors de la suppression du praticien"
    },
    "resetPassword": {
      "title": "Reinitialiser le mot de passe",
      "description": "Reinitialisez le mot de passe de {name}. Il sera notifie du nouveau mot de passe et devra le changer apres sa prochaine connexion.",
      "newPassword": "Nouveau mot de passe",
      "newPasswordPlaceholder": "Saisissez le nouveau mot de passe",
      "confirmPassword": "Confirmer le mot de passe",
      "confirmPasswordPlaceholder": "Confirmez le nouveau mot de passe",
      "generatePassword": "Generer un mot de passe securise",
      "showPassword": "Afficher le mot de passe",
      "hidePassword": "Masquer le mot de passe",
      "passwordMismatch": "Les mots de passe ne correspondent pas",
      "passwordTooShort": "Le mot de passe doit contenir au moins 6 caracteres",
      "warning": {
        "shareSecurely": "Assurez-vous de partager le nouveau mot de passe de maniere securisee"
      },
      "confirm": "Reinitialiser le mot de passe",
      "cancel": "Annuler",
      "success": "Mot de passe reinitialise avec succes",
      "error": "Echec de la reinitialisation du mot de passe"
    }
  },
  "groups": {
    "title": "Groupes",
    "description": "Gerez les groupes et assignez des membres pour le partage de patients",
    "createButton": "Creer un groupe",
    "noGroups": "Aucun groupe trouve",
    "memberCount": "{{count}} membre(s)",
    "create": {
      "title": "Creer un groupe",
      "description": "Creez un nouveau groupe pour organiser les membres de votre institution",
      "name": "Nom du groupe",
      "namePlaceholder": "Entrez le nom du groupe",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Entrez une description (optionnel)",
      "confirm": "Creer le groupe",
      "cancel": "Annuler"
    },
    "edit": {
      "title": "Modifier le groupe",
      "description": "Mettez a jour les informations du groupe",
      "confirm": "Enregistrer les modifications",
      "cancel": "Annuler"
    },
    "delete": {
      "title": "Supprimer le groupe",
      "description": "Etes-vous sur de vouloir supprimer le groupe \"{{name}}\" ? Cette action est irreversible.",
      "confirm": "Supprimer",
      "cancel": "Annuler"
    },
    "members": {
      "title": "Gerer les membres",
      "description": "Gerez les membres du groupe \"{{name}}\"",
      "addMember": "Ajouter un membre",
      "selectMember": "Selectionner un membre",
      "selectPlaceholder": "Choisir un membre...",
      "noAvailableMembers": "Tous les membres de l'institution sont deja dans ce groupe",
      "currentMembers": "Membres ({{count}})",
      "noMembers": "Aucun membre dans ce groupe pour le moment"
    }
  },
  "notifications": {
    "title": "Notifications",
    "description": "Restez informe des activites de votre institution",
    "unreadCount_one": "1 non lue",
    "unreadCount_other": "{{count}} non lues",
    "markAllRead": "Tout marquer comme lu",
    "time": {
      "justNow": "A l'instant",
      "hoursAgo_one": "Il y a 1 heure",
      "hoursAgo_other": "Il y a {{count}} heures",
      "yesterday": "Hier"
    },
    "empty": {
      "title": "Aucune notification",
      "description": "Vous n'avez pas encore de notifications. Elles apparaitront ici quand votre institution aura des activites."
    },
    "error": {
      "loadFailed": "Impossible de charger les notifications",
      "retry": "Reessayer"
    },
    "status": {
      "read": "Lu"
    }
  },
  "profile": {
    "title": "Profil de l'institution",
    "description": "Gerez les informations et parametres de votre institution",
    "tabs": {
      "personal": "Informations personnelles",
      "institution": "Informations de l'institution",
      "security": "Securite"
    },
    "personal": {
      "title": "Informations personnelles",
      "description": "Mettez a jour vos donnees personnelles",
      "success": "Informations mises a jour avec succes",
      "successDescription": "Les informations personnelles ont ete mises a jour avec succes",
      "error": "Erreur lors de la mise a jour des informations personnelles",
      "errorDescription": "Une erreur est survenue lors de la mise a jour des informations personnelles",
      "fields": {
        "firstName": "Prenom",
        "lastName": "Nom",
        "email": "Email",
        "phone": "Telephone",
        "gender": "Genre",
        "genderOptions": {
          "man": "Homme",
          "woman": "Femme",
          "other": "Autre"
        },
        "language": "Langue",
        "languageOptions": {
          "en": "Anglais",
          "fr": "Francais"
        },
        "theme": "Theme",
        "themeOptions": {
          "light": "Clair",
          "dark": "Sombre",
          "system": "Systeme"
        }
      },
      "saveChanges": "Enregistrer les modifications",
      "updating": "Mise a jour...",
      "personalization": {
        "title": "Personnalisation",
        "description": "Personnalisez votre experience"
      }
    },
    "institution": {
      "title": "Informations de l'institution",
      "description": "Consultez les donnees de votre institution",
      "updateNote": "Pour modifier les informations de l'institution, veuillez envoyer un email a support@metadevprofile.com avec les nouvelles informations.",
      "fields": {
        "institutionName": "Nom de l'institution",
        "companyRegistration": "Immatriculation",
        "address": "Adresse",
        "city": "Ville",
        "zipCode": "Code postal",
        "state": "Etat/Region",
        "country": "Pays"
      }
    },
    "security": {
      "title": "Parametres de securite",
      "description": "Gerez la securite de votre compte",
      "changePassword": {
        "title": "Changer le mot de passe",
        "description": "Mettez a jour le mot de passe de votre compte pour une securite renforcee.",
        "fields": {
          "currentPassword": "Mot de passe actuel",
          "newPassword": "Nouveau mot de passe",
          "confirmPassword": "Confirmer le nouveau mot de passe"
        },
        "button": "Mettre a jour le mot de passe",
        "updating": "Mise a jour...",
        "success": "Mot de passe mis a jour avec succes",
        "successDescription": "Le mot de passe a ete mis a jour avec succes",
        "error": "Erreur lors de la mise a jour du mot de passe",
        "errorDescription": "Une erreur est survenue lors de la mise a jour du mot de passe",
        "errors": {
          "currentRequired": "Le mot de passe actuel est requis",
          "newRequired": "Le nouveau mot de passe est requis",
          "confirmRequired": "Veuillez confirmer votre nouveau mot de passe",
          "minLength": "Le mot de passe doit contenir au moins 6 caracteres",
          "noMatch": "Les mots de passe ne correspondent pas",
          "samePassword": "Le nouveau mot de passe doit etre different de l'actuel",
          "wrongCurrent": "Le mot de passe actuel est incorrect"
        }
      },
      "twoFactor": {
        "title": "Authentification a deux facteurs",
        "description": "Ajoutez une couche de securite supplementaire a votre compte.",
        "button": "Activer la 2FA"
      }
    },
    "error": {
      "notFound": "Institution non trouvee",
      "description": "Impossible de charger les informations de l'institution"
    }
  },
  "billing": {
    "title": "Facturation",
    "description": "Gerez votre abonnement, moyen de paiement et factures",
    "subscription": {
      "title": "Abonnement",
      "seats": "Sieges",
      "monthlyCost": "Cout mensuel",
      "nextBilling": "Prochaine facturation",
      "trialingUntil": "Essai gratuit jusqu'au {{date}}",
      "paymentMethodNeededTitle": "Ajoutez un moyen de paiement",
      "paymentMethodNeededDescription": "Ajoutez un moyen de paiement avant le {{date}} pour conserver l'acces a votre compte.",
      "pausedTitle": "Abonnement en pause",
      "pausedDescription": "L'acces est bloque car aucun moyen de paiement n'a ete ajoute avant la fin de l'essai. Ajoutez une carte puis reprenez l'abonnement pour retrouver l'acces."
    },
    "paymentMethod": {
      "title": "Moyen de paiement",
      "change": "Modifier",
      "none": "Aucun moyen de paiement enregistre",
      "expires": "Expire",
      "dialogTitle": "Modifier le moyen de paiement",
      "dialogDescription": "Saisissez les informations de votre nouvelle carte ci-dessous.",
      "save": "Enregistrer la carte",
      "updateError": "Echec de la mise a jour du moyen de paiement"
    },
    "invoices": {
      "title": "Historique des factures",
      "none": "Aucune facture pour le moment",
      "status": {
        "paid": "Payee",
        "open": "Ouverte",
        "draft": "Brouillon",
        "uncollectible": "Irrecouvrable",
        "void": "Annulee"
      }
    },
    "cancel": {
      "button": "Annuler l'abonnement",
      "title": "Annuler l'abonnement",
      "description": "Etes-vous sur de vouloir annuler votre abonnement ? Il restera actif jusqu'a la fin de la periode de facturation en cours.",
      "confirm": "Confirmer l'annulation",
      "back": "Retour"
    },
    "reactivate": {
      "button": "Reactiver l'abonnement"
    },
    "resume": {
      "processing": "Paiement accepté, activation en cours...",
      "confirming": "Paiement en cours de confirmation, la page se mettra à jour sous peu",
      "button": "Reprendre l'abonnement",
      "paymentMethodRequired": "Ajoutez un moyen de paiement avant de reprendre l'abonnement."
    },
    "blocked": {
      "title": "Abonnement inactif",
      "description": "L'abonnement de votre institution est inactif. Veuillez contacter votre administrateur pour restaurer l'acces."
    }
  },
  "device": {
    "title": "Autorisation d'Appareils",
    "description": "Gérer les appareils autorisés pour votre institution : {{institution}}",
    "unknownInstitution": "Institution Inconnue",
    "unknownDevice": "Appareil Inconnu",
    "institutionMember": {
      "title": "Membre d'Institution",
      "description": "En tant que membre de {{institution}}, vos appareils nécessitent une autorisation pour des raisons de sécurité."
    },
    "authorizedDevices": {
      "title": "Appareils Autorisés",
      "empty": "Aucun appareil autorisé trouvé"
    },
    "authorizedOn": "Autorisé le",
    "status": {
      "authorized": "Autorisé",
      "pending": "En attente",
      "denied": "Refusé"
    },
    "info": {
      "note": "L'autorisation des appareils est gérée par l'administrateur de votre institution. Contactez-le pour les demandes d'approbation d'appareils."
    },
    "errors": {
      "approveDeviceFailed": "Échec de l'approbation de l'appareil",
      "denyDeviceFailed": "Échec du refus de l'appareil",
      "loadAuthorizationsFailed": "Échec du chargement des autorisations d'appareils",
      "loadPendingRequestsFailed": "Échec du chargement des demandes en attente",
      "loadUserAuthorizationsFailed": "Échec du chargement des autorisations utilisateur",
      "revokeDeviceFailed": "Échec de la révocation de l'autorisation de l'appareil"
    }
  },
  "success": {
    "institutionCreatedSuccessfully": "Institution créée avec succès",
    "paymentMethodUpdated": "Méthode de paiement mise à jour avec succès",
    "subscriptionResumed": "L'abonnement a été repris avec succès",
    "subscriptionCanceled": "L'abonnement sera annulé à la fin de la période en cours",
    "subscriptionReactivated": "L'abonnement a été réactivé avec succès",
    "institutionMemberCreatedSuccessfully": "Membre de l'institution créé avec succès",
    "institutionMemberUpdatedSuccessfully": "Membre de l'institution mis à jour avec succès",
    "memberRemovedSuccessfully": "Membre supprimé avec succès",
    "passwordResetSuccessfully": "Mot de passe réinitialisé avec succès",
    "groupCreated": "Groupe créé avec succès",
    "groupUpdated": "Groupe mis à jour avec succès",
    "groupDeleted": "Groupe supprimé avec succès",
    "groupMemberAdded": "Membre ajouté au groupe",
    "groupMemberRemoved": "Membre retiré du groupe",
    "deviceAuthorizationApprovedSuccessfully": "Autorisation de l'appareil approuvée avec succès",
    "deviceAuthorizationDeniedSuccessfully": "Autorisation de l'appareil refusée avec succès",
    "deviceAuthorizationRevokedSuccessfully": "Autorisation de l'appareil révoquée avec succès"
  },
  "errors": {
    "createUserFailed": "Echec de la creation de l'utilisateur",
    "createInstitutionFailed": "Echec de la creation de l'institution",
    "loadStatsFailed": "Echec du chargement des statistiques",
    "loadUsersFailed": "Echec du chargement des utilisateurs",
    "loadInstitutionFailed": "Echec du chargement de l'institution",
    "loadInstitutionsFailed": "Echec du chargement des institutions",
    "loadSubscriptionFailed": "Echec du chargement des informations d'abonnement",
    "loadSeatPreviewFailed": "Echec du chargement de l'apercu du cout du siege",
    "resetPasswordFailed": "Echec de la reinitialisation du mot de passe",
    "updateUserFailed": "Echec de la mise a jour du praticien",
    "deleteUserFailed": "Echec de la suppression du praticien",
    "updateInstitutionFailed": "Echec de la mise a jour de l'institution",
    "loadGroupsFailed": "Echec du chargement des groupes",
    "createGroupFailed": "Echec de la creation du groupe",
    "updateGroupFailed": "Echec de la mise a jour du groupe",
    "deleteGroupFailed": "Echec de la suppression du groupe",
    "addGroupMemberFailed": "Echec de l'ajout du membre au groupe",
    "removeGroupMemberFailed": "Echec de la suppression du membre du groupe",
    "loadPaymentMethodFailed": "Echec du chargement du moyen de paiement",
    "createSetupIntentFailed": "Echec de l'initialisation de la mise a jour de carte",
    "updatePaymentMethodFailed": "Echec de la mise a jour du moyen de paiement",
    "loadInvoicesFailed": "Echec du chargement des factures",
    "cancelSubscriptionFailed": "Echec de l'annulation de l'abonnement",
    "reactivateSubscriptionFailed": "Echec de la reactivation de l'abonnement",
    "resumeSubscriptionFailed": "Echec de la reprise de l'abonnement",
    "resumeSubscriptionPaymentFailed": "L'authentification du paiement a échoué. Veuillez réessayer.",
    "stripeUnavailable": "Service de paiement indisponible. Veuillez réessayer plus tard.",
    "trialSeatLimitReached": "Limite de sieges de l'essai atteinte"
  }
}
